import { render, staticRenderFns } from "./BoxContent6.vue?vue&type=template&id=287b13e7&scoped=true"
import script from "./BoxContent6.vue?vue&type=script&lang=js"
export * from "./BoxContent6.vue?vue&type=script&lang=js"
import style0 from "./BoxContent6.vue?vue&type=style&index=0&id=287b13e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b13e7",
  null
  
)

export default component.exports